import { Component, Inject, Input, Output, OnInit, EventEmitter } from 'ng-metadata/core';
import {PrimolyticsService} from '../../analytics/primolytics.service';
import {ResourceTypeFilterBarService} from './resourceTypeFilterBar.service';

const maxNumberofResourceToDisplay = 6;

@Component({
    selector: 'prm-resource-type-filter-bar',
    templateUrl: 'components/search/resourceTypeFilterBar/resource-type-filter-bar.html',
})

export class PrmResourceTypeFilterBar implements OnInit {

    @Input() selectedTab: string;
    @Input() public resourceTypeFilter: Object;
    @Output() public searchEvent = new EventEmitter();

    private resourceTypes: string[] = [];

    private resourceTypesFilter: string[];
    private MoreResourceTypes: string[] = [];
    private filterSelection: string;
    private morefilterSelection: string;

    private enableMoreResourceDropDown = false;
    private ALL_RESOURCE_TYPE_OPTION: string = 'all';
   

    constructor(@Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
        @Inject('$scope') private $scope: ng.IScope,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        @Inject('resourceTypeIcons') private resourceTypeIcons,
        private primolyticsService: PrimolyticsService,
        private resourceTypeFilterBarService : ResourceTypeFilterBarService) {


    }

    ngOnInit() {

        this.updateResourceTypeFilterData();
        this.getSelectedResourceTypeFromURL();


        // When Changing search tab 
        this.$scope.$watch(() => this.selectedTab, (newVal, oldVal) => {
            if (oldVal != newVal) {
                this.updateResourceTypeFilterData();
                this.getSelectedResourceTypeFromURL();
            }
        });

    }


    public onChanged(filterSelection) {
        this.filterSelection = filterSelection;
        // reset the dropdown more option to default
        if (this.MoreResourceTypes.indexOf(filterSelection) == -1 ){
            this.morefilterSelection = "";
        }
        this.resourceTypeFilter.mediaType = this.getValueExceptFor(this.filterSelection, this.ALL_RESOURCE_TYPE_OPTION);
        this.searchEvent.emit(Event);
    }

    public updateResourceTypeFilterData() {

        //check if to display option in this scope
        this.resourceTypes = this.resourceTypeFilterBarService.getResourceTypeFilter(this.selectedTab);
        if (!angular.isArray(this.resourceTypes)) {
            this.resourceTypes = [this.resourceTypes];
        }

        if (this.resourceTypes.length <= maxNumberofResourceToDisplay) {
            this.resourceTypesFilter = this.resourceTypes;
            this.enableMoreResourceDropDown = false;
        } else {

            this.resourceTypesFilter = this.resourceTypes.slice(0, maxNumberofResourceToDisplay);
            this.MoreResourceTypes = this.resourceTypes.slice(maxNumberofResourceToDisplay, this.resourceTypes.length);
            this.enableMoreResourceDropDown = true;
        }
        //Add All option 
        this.resourceTypesFilter.unshift(this.ALL_RESOURCE_TYPE_OPTION);

    }

    //If the default value "all" is selected then return empty value
    private getValueExceptFor(value, except) {
        if (value === except) {
            return;
        }
        return value;
    }

    //Get selected value from URL 
    public getSelectedResourceTypeFromURL() {
        let pFilter = this.$stateParams['pfilter'];

        if (pFilter) {
            if (!angular.isArray(pFilter)) {
                pFilter = [pFilter];
            }
            let pfilterName = ['rtype','pfilter'];
            pFilter = pFilter.filter((cur) => {
                return pfilterName.includes(cur.split(',')[0]);
            });
            if (pFilter && pFilter[0] && pFilter[0].split(',').length >= 3) {
                let resourceType = pFilter[0].split(',')[2];
                this.filterSelection = resourceType;
                if(this.MoreResourceTypes.indexOf(this.filterSelection) > -1){
                    this.morefilterSelection = resourceType;
                }
                //Fix for URM-189450 ( collection is indexed without s)
                if(this.filterSelection === "collection" && this.resourceTypes.indexOf("collections") !== -1){
                    this.filterSelection = "collections" ;
                }
                if(this.resourceTypes.indexOf(this.filterSelection) == -1){
                    this.filterSelection = this.ALL_RESOURCE_TYPE_OPTION;
                }
                this.resourceTypeFilter.mediaType = this.getValueExceptFor(this.filterSelection, this.ALL_RESOURCE_TYPE_OPTION);

            }
        } else {
            this.filterSelection = this.ALL_RESOURCE_TYPE_OPTION;
        }

    }

    //get translation
    public getTranslatedOptionLabel(resource) {
        if (!this.$translate.isReady()) {
            return undefined;
        }
        if (resource == this.ALL_RESOURCE_TYPE_OPTION) {
            return this.$translate.instant('nui.results.resourcesFiltersBar.All');
        }
        return this.$translate.instant('search-advanced.mediaType.option.' + resource);

    }


    private getAriaLabel(filter: string) {
        if (!this.$translate.isReady()) {
            return undefined;
        }
        if (filter == this.ALL_RESOURCE_TYPE_OPTION) {
            return this.$translate.instant('nui.aria.resourcesFiltersBar.All');
        }
        return this.$translate.instant('nui.aria.resourcesFiltersBar.filter', { filter_name: this.getTranslatedOptionLabel(filter) });
    }

    public isActive() {
        return this.filterSelection && this.MoreResourceTypes.indexOf(this.filterSelection) > -1;

    }

    //Analytics 
    private sendResourceTypeBeacon(resource) {
        let index = resource === this.ALL_RESOURCE_TYPE_OPTION ? 1 : this.resourceTypes.indexOf(resource) + 2;
        this.primolyticsService.doBeaconReport({
            'p': 'brief',
            'op': 'resourceFilter' + index,
            'O': resource
        }, this.primolyticsService.getTimestamp());
    }
    
    private sendMoreResourceTypeBeacon() {
		this.primolyticsService.doBeaconReport({
			'p': 'brief',
            'op': 'resourceFilterMore',
		}, this.primolyticsService.getTimestamp());
    }
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceTypeFilterBar/resourceTypeFilterBar.directive.ts